"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInExperiment = exports.useInExperiment = exports.RunningExperiments = void 0;
const react_1 = require("react");
const pages_and_experiments_1 = require("../experiments/pages-and-experiments");
const ExperimentsContext_1 = __importDefault(require("../context/ExperimentsContext"));
exports.RunningExperiments = pages_and_experiments_1.RunningExperiments.reduce((acc, curr) => ((acc[curr.name] = curr), acc), {});
const useInExperiment = (experiment) => {
    const experiments = (0, react_1.useContext)(ExperimentsContext_1.default);
    if (!experiment) {
        return false;
    }
    const { id } = experiment;
    return experiments[id];
};
exports.useInExperiment = useInExperiment;
const isInExperiment = (experiment, cookies) => {
    const { id } = experiment || { id: '' };
    return Boolean(Number(cookies[id]));
};
exports.isInExperiment = isInExperiment;
//# sourceMappingURL=useInExperiment.js.map